import React from 'react';
import { renderHTML } from '../Utility/helpers';

export default function RecipeCards({ recipes }) {
  if (recipes.length === 0) return false;

  return (
    <div>
      <div className=" divider divider--top">
        <div className="grid grid--between grid--bottom grid--no-gutter">
          <h2 className="cut-modal__recommendations-header u--margin-top-0 u--margin-bottom-0 u--margin-bottom-20-md-max">
            Recipes that Use this Cut
          </h2>
          <a href="/recipes/" className="btn btn--naked u--display-none-sm-max">
            View More
            <span className="icon-arrow-right-short u--margin-left-10"></span>
          </a>
        </div>
        <hr className="u--display-none-md-max" />
      </div>
      <div className="grid grid--card">
        {recipes.map((recipe, index) => (
          <div
            key={index}
            className="grid__col-xs-12 grid__col-md-6 grid__col-lg-3"
          >
            <article className="card card--recipe">
              <a href={recipe.url} className="card__link">
                <section className="card__header">
                  <div className="card__media">
                    <img src={recipe.image} alt={recipe.name} />
                  </div>
                </section>
                <section className="card__body">
                  <p className="card__taxonomy">
                    {renderHTML(recipe.related_taxonomic_term)}
                  </p>
                  <h4 className="card__title">{renderHTML(recipe.name)}</h4>
                  <section className="card__footer">
                    <div className="grid grid--card grid--reverse grid--middle">
                      <div className="grid__col-xs-12 grid__col-md-6 u--margin-top-10-max-sm u--margin-bottom-0">
                        <p className="card__rating">
                          <i className="icon-star"></i>
                          <i className="icon-star"></i>
                          <i className="icon-star"></i>
                          <i className="icon-star"></i>
                          <i className="icon-star"></i>
                        </p>
                      </div>
                      <div className="grid__col-xs-12 grid__col-md-6">
                        {recipe.cook_time && (
                          <p className="card__time">
                            <i className="icon-clock-time"></i>
                            {recipe.cook_time} MINS
                          </p>
                        )}
                      </div>
                    </div>
                  </section>
                </section>
              </a>
            </article>
          </div>
        ))}
      </div>
    </div>
  );
}
